<template>
    <f7-page name="meet-the-team"> 
       <bc-navbar></bc-navbar>    
       <div class="page_maincontent layout_fullwidth_padding" v-if="isLoadedPage">
          <a v-on:click="back">
            <img src="/static/images/icons/black/back.png" alt="" class="back_image_button" title="">
          </a>
          <p class='page-title'>{{titlePage}}</p>
          <div v-for="(departmen, counter) in teamList" :key="counter">
              <h3 v-if="departmen.departmentSales.length > 0" >{{departmen.departmentName}}</h3>
              <div class="page_single layout_fullwidth_padding">
                  <div class="swiper-container-team  swiper-container-horizontal" v-if="departmen.departmentSales.length > 0" >                               
                      <div class="swiper-wrapper" style="transition-duration: 0ms; transform: translate3d(0px, 0px, 0px);">
                          <div v-for="(teammate, index) in departmen.departmentSales"              
                                  :key="index"           
                                  class="swiper-slide team-block"
                                  v-on:touchstart="OnTouchStart($event)" 
                                  v-on:touchend="OnTouchEnd($event)" 
                                  @click="OnItemClick(teammate,$event)">
                                              <div class="close-panel">                                                                                          
                                                <img :src="teammate.photo" alt="" title="" class="sales-photo">
                                                <strong class="">{{teammate.fullName}}</strong>
                                                <span v-bind:style="{ 'background-color': customization.mainColor , 'color': customization.fontColor}">
                                                  {{teammate.title}}
                                                </span>
                                              </div>
                          </div>
                      </div>
                      <div class="swiper-pagination-team"><span class="swiper-pagination-bullet swiper-pagination-bullet-active"></span><span class="swiper-pagination-bullet"></span><span class="swiper-pagination-bullet"></span><span class="swiper-pagination-bullet"></span></div>
                  </div>
              </div>           
           </div>       
          </div>
          <div style="position: absolute; left: 50%;top:50%" v-if="!isLoadedPage">
              <div style="position: relative; left: -50%;"> 
                <looping-rhombuses-spinner  :animation-duration="2500" :rhombus-size="25" :color="customization.mainColor" /> 
              </div>
          </div>             
    </f7-page>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { LoopingRhombusesSpinner } from 'epic-spinners'

export default {
  name: 'meet-the-team-list',
  components: {
    LoopingRhombusesSpinner
  },
  mounted: function () {
    if (this.teamList.length === 0) {
      this.loadTeamList().then(function () {
        console.log(this.isLoadedPage)
        this.isLoadedPage = true
      }.bind(this))
    } else {
      this.isLoadedPage = true
    }
  },
  updated: function () {
    if (this.teamList.length > 0 && !this.isLoaded) {
      var elements = document.getElementsByClassName('swiper-container-team')
      var elementPaging = document.getElementsByClassName('swiper-pagination-team')
      for (var i = 0; i < elements.length; i++) {
        elements[i].className += ' swiperCount' + i
        elementPaging[i].className += ' swiperPagingCount' + i
        // eslint-disable-next-line        
        var swiper = new Swiper('.swiperCount' + i, {
          effect: 'slide',
          slidesPerView: 2,
          spaceBetween: 10,
          initialSlide: 0,
          slidesPerGroup: 2,
          pagination: '.swiperPagingCount' + i,
          loop: false,
          speed: 600
        })
      }
      this.isLoaded = true
    }
  },
  computed: {
    ...mapState({
      teamList: state => state.meetTheTeam.teamList,
      customization: state => state.common.customization
    }),
    ...mapGetters({
      titlePage: 'common/getMeetTheTeamButtonTitle'
    })
  },
  methods: {
    ...mapActions('meetTheTeam', [
      'loadTeamList', 'loadSalesPerson'
    ]),
    OnTouchStart (event) {
      this.touchEventStartHandler = event
      this.isClickFired = false
    },
    OnTouchEnd (event) {
      this.touchEventEndHandler = event
        // move swipe logic
      var diffX = 0
      var diffY = 0
      if (this.touchEventStartHandler.pageX === undefined) {
        var touchStartObj = this.touchEventStartHandler.changedTouches[0]
        var touchEndObj = this.touchEventEndHandler.changedTouches[0]

        diffX = Math.abs(touchStartObj.pageX - touchEndObj.pageX)
        diffY = Math.abs(touchStartObj.pageY - touchEndObj.pageY)
      } else {
        diffX = Math.abs(this.touchEventStartHandler.pageX - this.touchEventEndHandler.pageX)
        diffY = Math.abs(this.touchEventStartHandler.pageY - this.touchEventEndHandler.pageY)
      }
      var timeSpan = Math.abs(this.touchEventEndHandler.timeStamp - this.touchEventStartHandler.timeStamp)
      if (diffX <= 2 && diffY <= 2 && timeSpan <= 200) {
        this.isClickFired = true
      }
    },
    OnItemClick (teammate, event) {
      if (this.isClickFired) {
        if (!this.isTouch) {
          this.loadSalesPerson(teammate.salesPersonId)
          this.$router.load({ url: 'meet-the-team/' + teammate.salesPersonId })
        }
      }
    },
    back () {
      this.$router.load({ url: 'home' })
    }

  },
  data () {
    return {
      isTouch: false,
      touchEventStartHandler: undefined,
      touchEventEndHandler: undefined,
      isClickFired: true,
      isLoaded: false,
      isLoadedPage: false
    }
  }
}

</script>
<style>
.page-title{
      text-align: right;
    font-weight: bold;
    font-size: 20px;
    margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// meet-the-team.vue?b027e570